import { render, staticRenderFns } from "./CategoryInfo.vue?vue&type=template&id=b954d72c&scoped=true&"
import script from "./CategoryInfo.vue?vue&type=script&lang=js&"
export * from "./CategoryInfo.vue?vue&type=script&lang=js&"
import style0 from "./CategoryInfo.vue?vue&type=style&index=0&id=b954d72c&prod&lang=css&"
import style1 from "./CategoryInfo.vue?vue&type=style&index=1&id=b954d72c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b954d72c",
  null
  
)

export default component.exports